<template>
    <section class="contract-flow-content-first-config">
        <div class="configurations">
            <span class="text-config">1 - Configurações</span>
            <span class="define-signature">Faça as definições para assinatura digital do contrato</span>
        </div>

        <div class="flow-signature">
            <ui-input
                v-model="form.data.name"
                :maxlength="45"
                label="Informe o nome do fluxo de assinatura:"
                placeholder="Ex. Assinatura Contrato"
                required
            />
        </div>

        <div class="envelope-status">
            <div class="envelope-status-content">
                <div class="text-envelope-status">
                    <span class="status-title">Status do Envelope</span>

                    <span class="status-subtitle">Selecione o status que você deseja criar os envelopes.</span>
                </div>

                <div class="envelope-status-select">
                    <ui-select-v2
                        v-model="form.data.status"
                        :data="statusOptions"
                        placeholder="Selecione"
                        size="lg"
                        return-value="value"
                    />
                </div>
            </div>

            <div class="footer-button">
                <ui-button
                    :disabled="!canSubmit"
                    design="mw-200 primary lg"
                    @click="next">
                    Avançar
                </ui-button>
            </div>
        </div>
    </section>
</template>

<script>
	import { uiButton } from '@/components/ui/buttons'
	import { uiInput, uiSelectV2 } from '@/components/ui/form'

    import { status } from '@/assets/js/data'

    import { mapActions, mapGetters } from 'vuex'

	export default {
		name: 'ui-docu-sign-contract-sign-flow-config',

		components: {
			uiButton,
            uiInput,
            uiSelectV2
		},

        data() {
            return {
                form: {
                    data: {
                        name: '',
                        status: null
                    }
                },
                statusOptions: [...status],
                unsubscribe: null
            }
        },

        computed: {
            ...mapGetters('digitalSignatureStore', {
                envelope: 'getEnvelope'
            }),
            /**
             * Computed property que define se as configurações podem ser salvas
             */
			canSubmit() {
				return this.form.data.name && this.form.data.status
			}
        },

        created() {
			/** Subscreve para uma mutation */
            this.unsubscribe = this.$store.subscribe((mutation) => {
                // Verifica se uma nova configuração de envelope foi setada
                if (mutation.type === 'digitalSignatureStore/SET_ENVELOPE') {
                    // Copia as configurações de envelope para o formulário, com exceção do nome
                    if (!mutation.payload?.name) {
                        this.form.data = {
                            ...mutation.payload,
                            name: ''
                        }
                    }
                }
            })
        },

        beforeDestroy() {
            this.unsubscribe()
        },

        methods: {
            ...mapActions('digitalSignatureStore', ['setEnvelope']),
            /**
             * Salva as configurações e passa para a próxima etapa
             */
			next() {
                this.setEnvelope(this.form.data)
                this.$emit('next')
            }
        }
	}
</script>

<style lang="stylus" scoped>
	@import './styles.styl'
</style>